import { render, staticRenderFns } from "./NewDriverEntity.vue?vue&type=template&id=80c389a6&scoped=true&"
import script from "./NewDriverEntity.vue?vue&type=script&lang=js&"
export * from "./NewDriverEntity.vue?vue&type=script&lang=js&"
import style0 from "./NewDriverEntity.vue?vue&type=style&index=0&id=80c389a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c389a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80c389a6')) {
      api.createRecord('80c389a6', component.options)
    } else {
      api.reload('80c389a6', component.options)
    }
    module.hot.accept("./NewDriverEntity.vue?vue&type=template&id=80c389a6&scoped=true&", function () {
      api.rerender('80c389a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Entities/NewDriverEntity.vue"
export default component.exports